import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";
const postCategory = {
  state: {
    idMenuArray: [],
    list: [],
    listAll: [],
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
    changeIdMenuArray(state, payload) {
      state.idMenuArray = payload;
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async getListMultiLevel(payload, rootState) {
      const _this = this;
      let token = rootState.user.token;
      let decode = await jwt.decode(token);
      let dataDecode = JSON.parse(decode.data);
      let serviceCode = rootState.service.adminService
        ? rootState.service.adminService.no
        : null;
      let data = {
        serviceCode: serviceCode,
        userCode: dataDecode.userCode,
      };
      let url =
        DomainAPI + Channel + "/api/secure/postCategories/getListMultiLevel";

      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) _this.setState({ list: result.data });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getList(payload = {}, rootState) {
      const _this = this;
      let token = rootState.user.token;
      let decode = await jwt.decode(token);
      let dataDecode = JSON.parse(decode.data);
      let serviceCode = rootState.service.adminService
        ? rootState.service.adminService.no
        : null;
      let data = {
        serviceCode: serviceCode,
        userCode: dataDecode.userCode,
        search: payload.search,
      };
      let url = DomainAPI + Channel + "/api/secure/postCategories/getList";

      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1 && !payload.not_save)
            _this.setState({ list: result.data });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async edit(payload, rootState) {
      let serviceCode = rootState.service.adminService
        ? rootState.service.adminService.no
        : null;
      let url = DomainAPI + Channel + "/api/secure/postCategories/edit";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          serviceCode: serviceCode,
          name: payload.name,
          parentCode: payload.parentCode,
          id: payload.id,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async add(payload, rootState) {
      let url = DomainAPI + Channel + "/api/secure/postCategories/add";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null || null,
          name: payload.name,
          parentCode: payload.parentCode,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async delete(payload, rootState) {
      let serviceCode = rootState.service.adminService
        ? rootState.service.adminService.no
        : null;
      let data = {
        serviceCode: serviceCode,
        id: payload.id,
      };
      let url = DomainAPI + Channel + "/api/secure/postCategories/delete";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default postCategory;
